import { Language } from '^/types';

export default {
  signup: {
    [Language.KO_KR]: 'Microsoft 계정으로 가입하기',
    [Language.EN_US]: 'Sign up with Microsoft',
  },
  signin: {
    [Language.KO_KR]: 'Microsoft로 로그인',
    [Language.EN_US]: 'Continue with Microsoft',
  },
};
